const strings = {
  title: 'Interações com Agricultor',
}

export default strings
